<template>
  <div>
    <h2>{{ header[locale][type] }}</h2>
    <div class="my-4" v-for="field in fields[type][locale]" :key="field.uid">
      <p v-if="field.text">{{ field.text }}</p>
      <v-text-field
        v-if="field.type === 'tf'"
        :label="field.label"
        v-model="result[field.model]"
        :rules="rules.required[locale]"
        outlined
      ></v-text-field>
      <v-text-field
        v-if="field.type === 'email'"
        :label="field.label"
        v-model="result[field.model]"
        :rules="rules.email[locale]"
        outlined
      >
      </v-text-field>
      <v-row v-if="field.type === 'tf+tf' && type === 'D3'">
        <v-col v-for="(f, i) in field.labels" :key="i + 23">
          <v-text-field
            :label="f"
            v-model="result[field.models[i]]"
	    :rules="rules.required[locale]"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="field.type === 'tf+tf' && type !== 'D3'">
        <v-col v-for="(f, i) in field.labels" :key="i + 23">
          <v-text-field
		v-if="i == 0"
            :label="f"
	    :rules="rules.required[locale]"
            v-model="result[field.models[i]]"
            outlined
          ></v-text-field>
          <v-text-field
		v-if="i == 1"
            :label="f"
            v-model="result[field.models[i]]"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <ExtraEmails
        v-if="field.type === 'extraEmail'"
        v-model="result[field.model]"
        :rules="rules.email[locale]"
      />
      <v-select
        v-if="field.type === 'multiLangSelect'"
        :items="langItems"
        multiple
        outlined
        chips
        v-model="result[field.model]"
      ></v-select>
      <v-select
        v-if="field.type === 'langSelect'"
        :items="langItems"
        :rules="rules.required[locale]"
        v-model="result[field.model]"
        outlined
      ></v-select>
    </div>
    <div>
      <p>{{ fields.part[type][locale].text }}</p>
      <v-select
        :items="fields.part[type][locale].items"
        v-model="partResult"
        outlined
      ></v-select>
    </div>
  </div>
</template>

<script>
import { emailRules, requiredRule } from "@/common/formRules.js";
import langItems from "@/common/languages.js";
import ExtraEmails from "./ExtraEmails.vue";
import ContactInfoFields from "./ContactInfoFields.js";

export default {
  name: "ContactInfo",
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
      required: true
    },
    locale: {
      type: String
    },
    part: {
      type: String
    },
    type: String
  },
  components: {
    ExtraEmails
  },
  data() {
    return {
      fields: ContactInfoFields,
      rules: {
        email: emailRules,
        required: requiredRule
      },
      langItems: langItems,
      header: {
        sv: {
          D1: "Fyll i följande information, tack!",
          D3: "Fyll i följande information, tack!"
        },
	en: {
	  D1: "Fill in the following details, please!",
	  D3: "Fill in the following details, please!"
	},
	ar: {
	  D1: "!املأ المعلومات التالية، شكرا",
	  D3: "!املأ المعلومات التالية، شكرا"
	}
      }
    };
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    partResult: {
      get() {
        return this.part;
      },
      set(value) {
        this.$emit("part", value);
      }
    }
  }
};
</script>

<style></style>
